// type TagEnum = 'success' | 'info' | 'warning' | 'danger' | 'cyan' | 'blue' | 'red' | 'orange' | 'green' | 'gray'

export var defaultFormData = {
  applicationId: '',
  // 所属应用
  day1RewardType: 1,
  // 第1天奖励类型
  day1RewardAmount: 0,
  // 第1天奖励数量
  day1DoubleRewardSwitch: 0,
  day1DoubleRewardMultiple: 0,
  day2RewardType: 1,
  // 第2天奖励类型
  day2RewardAmount: 0,
  // 第2天奖励数量
  day2DoubleRewardSwitch: 0,
  day2DoubleRewardMultiple: 0,
  day3RewardType: 1,
  // 第3天奖励类型
  day3RewardAmount: 0,
  // 第3天奖励数量
  day3DoubleRewardSwitch: 0,
  day3DoubleRewardMultiple: 0,
  day4RewardType: 1,
  // 第4天奖励类型
  day4RewardAmount: 0,
  // 第4天奖励数量
  day4DoubleRewardSwitch: 0,
  day4DoubleRewardMultiple: 0,
  day5RewardType: 1,
  // 第5天奖励类型
  day5RewardAmount: 0,
  // 第5天奖励数量
  day5DoubleRewardSwitch: 0,
  day5DoubleRewardMultiple: 0,
  day6RewardType: 1,
  // 第6天奖励类型
  day6RewardAmount: 0,
  // 第6天奖励数量
  day6DoubleRewardSwitch: 0,
  day6DoubleRewardMultiple: 0,
  day7RewardType: 1,
  // 第7天奖励类型
  day7RewardAmount: 0,
  // 第7天奖励数量
  day7DoubleRewardSwitch: 0,
  day7DoubleRewardMultiple: 0
};
export var formRules = {
  applicationId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择所属应用'
  }],
  day1RewardType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第1天奖励类型'
  }],
  day1RewardAmount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写第1天奖励数量'
  }],
  day2RewardType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第2天奖励类型'
  }],
  day2RewardAmount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写第2天奖励数量'
  }],
  day3RewardType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第3天奖励类型'
  }],
  day3RewardAmount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写第3天奖励数量'
  }],
  day4RewardType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第4天奖励类型'
  }],
  day4RewardAmount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写第4天奖励数量'
  }],
  day5RewardType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第5天奖励类型'
  }],
  day5RewardAmount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写第5天奖励数量'
  }],
  day6RewardType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第6天奖励类型'
  }],
  day6RewardAmount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写第6天奖励数量'
  }],
  day7RewardType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第7天奖励类型'
  }],
  day7RewardAmount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写第7天奖励数量'
  }]
};